import { Task } from '../../../../therapist/pages/tasks/types/Task'
import { axios, Response } from '../index'

const getTaskById = (taskId: string): Response<Task> => {
  return axios.get(`/v1/tasks/${taskId}`)
}
export default getTaskById
